export enum Address {
    SHIPPING = 'shipping',
    BILLING = 'billing',
    BILLING_AND_SHIPPING = 'billing&shipping',
    SHIPPING_ADDRESS = 'shippingAddress',
    BILLING_ADDRESS = 'billingAddress',
    DELIVERY = 'delivery',
    MAXIMUM_RESULTS_TO_SHOW = 7,
    LOQATE_VALIDATED = 'LOQATE_VALIDATED',
    UNKNOWN = 'UNKNOWN',
    USER_VALIDATED = 'USER_VALIDATED',
    PAYPAL_VALIDATED = 'PAYPAL_VALIDATED',
    APPLE_PAY_VALIDATED = 'APPLE_PAY_VALIDATED',
    NEW_FORM = 'NEW_FORM',
    EDIT_FORM = 'EDIT_FORM'
}

export enum AddressSource {
    MATRIX = 'Matrix',
    WEB = 'Web',
    POC = 'POC'
}

export enum LoginUserEditFormState {
    OPEN = 'open',
    CLOSE = 'close',
    FLOW = 'NORMAL'
}

export enum EmailValidationStatus {
    TIMEOUT = 'Timeout',
    INVALID = 'Invalid'
}

export enum ErrorMessage {
    INVALID_STATE = 'Invalid state for delivery'
}